export const DAY_HOURS = 24;

export const DAY_MILLIS = 86400000;

export const MIN_VALID_MILLIS = 86340000;

export const SHORT_DAY_MIN_VALID_MILLIS = 82740000;

export const PRELOAD_MODULES = true;

export const SEARCH_SELECT_CHARACTERS = 2;

export const MIN_RESOLUTION_FOR_DESKTOP = 1024;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/config/constants.ts